import React, { useState } from "react";

import './styles.css'

import CloseIcon from '@mui/icons-material/Close';
import {
  Stack,
  IconButton,
  //CardHeader,
  Box,
  Typography,
  Button,
  Grid
} from '@mui/material';

import AddIcon from '@mui/icons-material/Add';
import RemoveRoundedIcon from '@mui/icons-material/RemoveRounded';

function EditExerc(props){
  //const [choose, setChoose] = useState('Disponível');

  //const handleChoose = () => {
  //  setChoose('Escolhido');
  //}
    
    const [reps,setReps] = useState(props.content.reps);
    const [series,setSeries] = useState(props.content.series);
    const [tempoAposSerie,setTempoAposSerie] = useState(props.content.descansoAposSerie);
    const [tempoAposEX,setTempoAposEX] = useState(props.content.descansoAposExercicio);
    const [tempoLimite,setTempoLimite] = useState(props.content.tempoLimite);
    const [tempoManutencao,setTempoManutencao] = useState(props.content.tempoManutencao);

    function removeTempoLimite(nr){
        //console.log(nr)
        if(nr>1){
            setTempoLimite(nr-1);
        }else{
            setTempoLimite('N.D');
        }
        
    }
    function addTempoLimite(nr){
        console.log(nr)
        if(nr > 0){
            setTempoLimite(nr+1);
        }
        else{
            setTempoLimite(1);
        }
        if(nr<1){
            setTempoLimite('N.D');
        }
    }

    function removeTempoManutencao(nr){
        if(nr>1){
            setTempoManutencao(nr-1);
        }else{
            setTempoManutencao('N.D');
        }
    }

    function addTempoManutencao(nr){
        if(nr > 0){
            setTempoManutencao(nr+1);
        }else{
            setTempoManutencao(1);
        }
        if(nr<1){
            setTempoManutencao('N.D');
        }
    }

  return (props.trigger) ? (
    <Box className="popup">
        <Box className="popup-inner">
            {/*props.ex.membros {props.ex.name} */ }
            
            <Typography sx={{paddingTop:0.7}} variant="subtitle1">{props.content.name}</Typography>
            
            <Grid container justifyContent="flex-end">
                
                    <Stack direction="row" sx={{display:'flex',alignItems: 'center'}}>
                        <Typography variant="body2"> 
                            N.º de repetições: {reps} 
                        </Typography>

                        
                        <IconButton color='primary' size="small" variant="contained" onClick= {() => setReps(reps-1)}>
                            <RemoveRoundedIcon />
                        </IconButton>

                        <IconButton color='primary' size="small" variant="contained" onClick= {() => setReps(reps+1)}>
                            <AddIcon/>
                        </IconButton>
                    </Stack>
            

            <Stack direction="row" sx={{display:'flex',alignItems: 'center'}}>
                
                    <Typography variant="body2"> 
                        N.º de séries: {series}
                    </Typography>
                
                <IconButton size="small" color='primary'  variant="contained" onClick= {() => setSeries(series-1)}>
                    <RemoveRoundedIcon />
                </IconButton>

                <IconButton size="small" color='primary' variant="contained" onClick= {() => setSeries(series+1)}>
                    <AddIcon/>
                </IconButton>
            </Stack>
            
            <Stack direction="row" sx={{display:'flex',alignItems: 'center'}}>
                
                    <Typography variant="body2"> 
                        Após série: {tempoAposSerie}s
                    </Typography>
                
                <IconButton size="small" color='primary' variant="contained" onClick= {() => setTempoAposSerie(tempoAposSerie-1)}>
                    <RemoveRoundedIcon />
                </IconButton>

                <IconButton size="small" color='primary' variant="contained" onClick= {() => setTempoAposSerie(tempoAposSerie+1)}>
                    <AddIcon/>
                </IconButton>
            </Stack>

            <Stack direction="row" sx={{display:'flex',alignItems: 'center'}}>
                
                <Typography variant="body2"> 
                    Após exerc.: {tempoAposEX}s
                </Typography>

                <IconButton size="small" color='primary' variant="contained" onClick= {() => setTempoAposEX(tempoAposEX-1)}>
                    <RemoveRoundedIcon />
                </IconButton>

                <IconButton size="small" color='primary' variant="contained" onClick= {() => setTempoAposEX(tempoAposEX+1)}>
                    <AddIcon/>
                </IconButton>
            </Stack>

            <Stack direction="row" sx={{display:'flex',alignItems: 'center'}}>
                
                    <Typography variant="body2"> 
                        Limite: {tempoLimite}s
                    </Typography>
                
                <IconButton size="small" color='primary' variant="contained" onClick= {() => removeTempoLimite(tempoLimite)}>
                    <RemoveRoundedIcon />
                </IconButton>

                <IconButton size="small" color='primary'  variant="contained" onClick= {() => addTempoLimite(tempoLimite)}>
                    <AddIcon/>
                </IconButton>
            </Stack>

            <Stack direction="row" sx={{display:'flex',alignItems: 'center'}}>
                
                    <Typography variant="body2"> 
                        Permanência: {tempoManutencao}s 
                    </Typography>
                
                <IconButton size="small" color='primary' variant="contained" onClick= {() => removeTempoManutencao(tempoManutencao)}>
                    <RemoveRoundedIcon />
                </IconButton>

                <IconButton size="small" color='primary' variant="contained" onClick= {() => addTempoManutencao(tempoManutencao)}>
                    <AddIcon/>
                </IconButton>
            </Stack>

            <Button variant='contained' color='primary'>Guardar</Button>     
            </Grid>

                   

            <IconButton className="close-btn" onClick={() => props.setTrigger(false)}>
                <CloseIcon/>
            </IconButton>
            {props.children}
        </Box>
    </Box>

      /*
      <div className="popup">
        <div className="popup-inner">
            <button className="close-btn" onClick={() => props.setTrigger(false)}>
            Fechar
            </button>
            {props.children}
        </div>
    </div>
    */
  ) : "";
}
export default EditExerc
